/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CodeInterpreterOutputImage = {
  type: "image";
  url: string;
};

/** @internal */
export const CodeInterpreterOutputImage$inboundSchema: z.ZodType<
  CodeInterpreterOutputImage,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("image"),
  url: z.string(),
});
/** @internal */
export type CodeInterpreterOutputImage$Outbound = {
  type: "image";
  url: string;
};

/** @internal */
export const CodeInterpreterOutputImage$outboundSchema: z.ZodType<
  CodeInterpreterOutputImage$Outbound,
  z.ZodTypeDef,
  CodeInterpreterOutputImage
> = z.object({
  type: z.literal("image"),
  url: z.string(),
});

export function codeInterpreterOutputImageToJSON(
  codeInterpreterOutputImage: CodeInterpreterOutputImage,
): string {
  return JSON.stringify(
    CodeInterpreterOutputImage$outboundSchema.parse(codeInterpreterOutputImage),
  );
}
export function codeInterpreterOutputImageFromJSON(
  jsonString: string,
): SafeParseResult<CodeInterpreterOutputImage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CodeInterpreterOutputImage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CodeInterpreterOutputImage' from JSON`,
  );
}
